export enum AddressQualityEnum {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High'
}
